import { Pipeable } from '../Pipeable/index.js';
const CommonPrototype = {
    pipe() {
        return Pipeable.pipeArguments(this, arguments);
    },
};
const LoadingPrototype = Object.assign(Object.create(CommonPrototype), {
    type: 'Loading',
    loading: true,
    toJSON() {
        return {
            type: this.type,
            loading: this.loading,
        };
    },
    [Symbol.toStringTag]: 'Loading',
});
const _loading = Object.create(LoadingPrototype);
export const loading = () => _loading;
const SuccessPrototype = Object.assign(Object.create(CommonPrototype), {
    type: 'Success',
    loading: false,
    toJSON() {
        return {
            type: this.type,
            loading: this.loading,
            value: this.value,
        };
    },
    [Symbol.toStringTag]: 'Success',
});
export const success = (value) => {
    const success = Object.create(SuccessPrototype);
    success.value = value;
    return success;
};
const ErrorPrototype = Object.assign(Object.create(CommonPrototype), {
    type: 'Error',
    loading: false,
    toJSON() {
        return {
            type: this.type,
            loading: this.loading,
            error: this.error,
        };
    },
    [Symbol.toStringTag]: 'Error',
});
export const error = (error) => {
    const err = Object.create(ErrorPrototype);
    err.error = error;
    return err;
};
const NotInitiatedPrototype = Object.assign(Object.create(CommonPrototype), {
    type: 'NotInitiated',
    loading: false,
    toJSON() {
        return {
            type: this.type,
            loading: this.loading,
        };
    },
    [Symbol.toStringTag]: 'NotInitiated',
});
const _notInitiated = Object.create(NotInitiatedPrototype, {});
export const notInitiated = () => _notInitiated;
//# sourceMappingURL=base.js.map